(function () {
  if (window.__digDiscountsBound) return;
  window.__digDiscountsBound = true;

  function applyDiscountSilently(code) {
    return fetch('/discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'manual'
    }).catch(function () { /* cookie may still be set; ignore */ });
  }

  function getMiniCart() {
    return document.querySelector('mini-cart');
  }

  function getSectionsToRender() {
    var miniCart = getMiniCart();
    if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
      return miniCart.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  }

  function getQtyInput(el) {
    var card = el.closest('.dig-card');
    return card ? card.querySelector('[data-dig-qty-input]') : null;
  }

  function readQty(input) {
    var q = parseInt(input && input.value, 10);
    if (isNaN(q) || q < 1) q = 1;
    return q;
  }

  // +/- steppers
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-dig-qty-minus], [data-dig-qty-plus]');
    if (!step) return;
    var input = getQtyInput(step);
    if (!input) return;
    var q = readQty(input);
    q = step.hasAttribute('data-dig-qty-plus') ? q + 1 : Math.max(1, q - 1);
    input.value = q;
  });

  // Normalize a manually typed value when the field loses focus / commits
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-dig-qty-input]');
    if (!input) return;
    input.value = readQty(input);
  });

  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-dig-add]');
    if (!btn || btn.disabled) return;

    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var discountCode = btn.getAttribute('data-discount-code');
    if (!variantId || !discountCode) return;

    var quantity = readQty(getQtyInput(btn));

    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      await applyDiscountSilently(discountCode);

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: quantity,
          sections: getSectionsToRender(),
          sections_url: window.location.pathname
        })
      });

      var parsedState = await addRes.json();

      if (!addRes.ok || parsedState.status === 422) {
        throw new Error(parsedState.description || parsedState.message || 'Could not add to cart');
      }

      var miniCart = getMiniCart();
      if (miniCart && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(parsedState);
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
      }
    } catch (e) {
      console.error('[dig-discounts]', e);
      alert('Sorry — we could not add this item. Please refresh and try again.');
    } finally {
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  });
})();

// (function () {
//   if (window.__digDiscountsBound) return;
//   window.__digDiscountsBound = true;

//   function applyDiscountSilently(code) {
//     return fetch('/discount/' + encodeURIComponent(code), {
//       credentials: 'same-origin',
//       redirect: 'manual'
//     }).catch(function () { /* cookie may still be set; ignore */ });
//   }

//   function getMiniCart() {
//     return document.querySelector('mini-cart');
//   }

//   function getSectionsToRender() {
//     var miniCart = getMiniCart();
//     if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
//       return miniCart.getSectionsToRender().map(function (s) { return s.id; });
//     }
//     return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
//   }

//   document.addEventListener('click', async function (event) {
//     var btn = event.target.closest('[data-dig-add]');
//     if (!btn || btn.disabled) return;

//     event.preventDefault();

//     var variantId = btn.getAttribute('data-variant-id');
//     var discountCode = btn.getAttribute('data-discount-code');
//     if (!variantId || !discountCode) return;

//     var originalLabel = btn.textContent;
//     btn.disabled = true;
//     btn.textContent = 'Adding…';

//     try {
//       await applyDiscountSilently(discountCode);

//       var addRes = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//         body: JSON.stringify({
//           id: Number(variantId),
//           quantity: 1,
//           sections: getSectionsToRender(),
//           sections_url: window.location.pathname
//         })
//       });

//       var parsedState = await addRes.json();

//       if (!addRes.ok || parsedState.status === 422) {
//         throw new Error(parsedState.description || parsedState.message || 'Could not add to cart');
//       }

//       var miniCart = getMiniCart();
//       if (miniCart && typeof miniCart.renderContents === 'function') {
//         miniCart.renderContents(parsedState);
//       } else {
//         document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
//       }
//     } catch (e) {
//       console.error('[dig-discounts]', e);
//       alert('Sorry — we could not add this item. Please refresh and try again.');
//     } finally {
//       btn.disabled = false;
//       btn.textContent = originalLabel;
//     }
//   });
// })();
